import { makeStyles } from "@material-ui/core";

export const vehicleActivityLogStyle = makeStyles((theme) => ({
    activityItem: {
        borderBottom: '1px solid #e0e0e0',
        padding: '1em 0 1em 5em',
        position: "relative",
        backgroundColor: 'transparent',
        transition: 'background-color 0.2s ease',
    },
    headerRow: {
        borderBottom: '1px solid #e0e0e0',
        fontWeight: '500',
        padding: '1em 0 1em 5em',
    },
    collapseWrapper: {
        width: '100%'
    },
    expandedGroup: {
        boxShadow: '1px 2px 7px #ddd',
        backgroundColor: '#f4f4f4'
    },
    expandIcon: {
        // animation: "$spin 1s 1",
        position: "absolute",
        left: '-0.1em'
    },
    flag: {
        position: "absolute",
        left: '1.7em'
    },
    expanded: {
        transform: "rotate(90deg)",
    },
    expandedRow: {
        fontWeight: 600,
        marginBottom: '1em'
    },
    activityLogHeader: {
        color: theme.palette.primary.main,
        padding: '2px'
    },
    activityCell: {
        padding: '2px'
    },
    actionButton: {
        width: '100%',
        justifyContent: 'start'
    },
    actionCellContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    bundleTooltip: {
        backgroundColor: '#1F2430',
        color: '#F5F7FA',
        borderRadius: 10,
        padding: '10px 12px',
        lineHeight: 1.45,
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.24)',
        maxWidth: 320,
        fontWeight: 400
    },
    bundleTooltipArrow: {
        color: '#1F2430'
    },
    bundleTooltipTitle: {
        fontWeight: 600,
        fontSize: 13
    },
    bundleTooltipId: {
        marginTop: 4,
        fontSize: 12,
        color: 'rgba(245, 247, 250, 0.78)'
    },
    bundleTooltipTrigger: {
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'default'
    },
    bundleTooltipIcon: {
        marginLeft: 4,
        verticalAlign: 'middle',
        display: 'inline-flex'
    }
}));